/**
 * @generated SignedSource<<94eb3fdf1c5d1f4a937bdbb21018effa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeployBindingMutation$variables = {
  uuid: string;
};
export type DeployBindingMutation$data = {
  readonly deployBinding: {
    readonly binding: {
      readonly deployment: {
        readonly percentageDeployed: number;
      } | null | undefined;
      readonly lastDeployed: string | null | undefined;
      readonly name: string;
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type DeployBindingMutation = {
  response: DeployBindingMutation$data;
  variables: DeployBindingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "BindingDeployment",
  "kind": "LinkedField",
  "name": "deployment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageDeployed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDeployed",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeployBindingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "BindingPayload",
        "kind": "LinkedField",
        "name": "deployBinding",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Binding",
            "kind": "LinkedField",
            "name": "binding",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DeployBindingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "BindingPayload",
        "kind": "LinkedField",
        "name": "deployBinding",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Binding",
            "kind": "LinkedField",
            "name": "binding",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f551dae03775a504c84fa99e48beba22",
    "id": null,
    "metadata": {},
    "name": "DeployBindingMutation",
    "operationKind": "mutation",
    "text": "mutation DeployBindingMutation(\n  $uuid: String!\n) {\n  deployBinding(uuid: $uuid) {\n    binding {\n      deployment {\n        percentageDeployed\n      }\n      lastDeployed\n      name\n      uuid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c60449747ef30d846be6f7c48440e40";

export default node;
